import { useFormikContext } from "formik";
import React, { useEffect } from "react";

const FormikNotify = ({ onChange = () => {} }) => {
  const { values, errors, touched } = useFormikContext();

  useEffect(() => {
    onChange({
      values,
      errors,
      touched,
    });
  }, [values, errors, touched]);

  return null;
};

export default FormikNotify;
